import { Weddings } from '@bridebook/models';
import type { IWedding_RSVP } from '@bridebook/models/source/models/Weddings.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WEDDING_RSVP_ROOT_QUERY_KEY } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import { useSelector } from '@bridebook/web/lib/utils';
import { getWeddingId } from '@bridebook/web/lib/weddings/selectors';

export const useUpdateWeddingRsvp = () => {
  const queryClient = useQueryClient();
  const weddingId = useSelector(getWeddingId);
  const mutation = useMutation({
    mutationFn: async (rsvp: Partial<IWedding_RSVP>) => {
      await Weddings._.getById(weddingId).set({ rsvp }, true);
      return rsvp;
    },
    onSettled: () => {
      // Invalidate rather than cache-set: the payload may contain Firestore
      // FieldValue sentinels (e.g. deleteField()) that crash downstream readers.
      queryClient.invalidateQueries([WEDDING_RSVP_ROOT_QUERY_KEY, 'single', weddingId]);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};
